import React from "react";

import { ArrowLeft, Trash2 } from "react-feather";
import {
  Grid,
  TextField,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import Button from "@ds-developer/button";

import { default as BaseModal } from "@ds-developer/modal";
import { DeleteAreaConfirmationModalProps } from "./types";

const useStyles = makeStyles(theme => ({
  firstParagraph: {
    marginBottom: "12px",
  },
  secondParagraph: {
    marginBottom: theme.spacing(3),
  },
  cancelButtonContainer: {
    textAlign: "end",
  },
  confirmationField: {
    minWidth: "300px",
  },
  delete: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const DeleteAreaConfirmationModal: React.FC<DeleteAreaConfirmationModalProps> = ({
  disabled = true,
  onCancelClick,
  onConfirmClick,
  register,
  loading = false,
  submitting,
  handleInputFieldEvent,
}) => {
  const classes = useStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <BaseModal
      open
      actions={
        <Grid
          container
          direction={isMobile ? "column" : "row"}
          spacing={2}
          alignItems="center"
        >
          <Grid item xs={12} sm={6}>
            <Button
              color="error"
              disabled={disabled || submitting}
              onClick={onConfirmClick}
              startIcon={<Trash2 size={18} />}
              variant="contained"
              loading={loading}
              data-test="delete-area-button"
            >
              Delete this area
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.cancelButtonContainer}>
            <Button
              color="success"
              disabled={submitting}
              onClick={onCancelClick}
              startIcon={<ArrowLeft size={18} />}
              variant="contained"
            >
              I want to keep this area
            </Button>
          </Grid>
        </Grid>
      }
      title="Confirm you want to delete an area"
    >
      <Typography className={classes.firstParagraph} color="error" variant="h3">
        Once you delete this area, it cannot be recovered. You will have to set
        it up again from the beginning.
      </Typography>
      <Typography className={classes.secondParagraph} variant="body1">
        To complete, type the word{" "}
        <span className={classes.delete}>delete</span> into the box below and
        then press the “Delete this area” button
      </Typography>

      <TextField
        name="confirmation"
        className={classes.confirmationField}
        fullWidth={isMobile}
        placeholder={'Type "delete" here to confirm'}
        variant="outlined"
        inputRef={register}
        inputProps={{
          ["data-test"]: "delete-area-confirmation-input",
        }}
        onClick={handleInputFieldEvent}
      />
    </BaseModal>
  );
};

export default DeleteAreaConfirmationModal;
